import { render, staticRenderFns } from "./news-container.vue?vue&type=template&id=7af6ca96&"
import script from "./news-container.vue?vue&type=script&lang=js&"
export * from "./news-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7af6ca96', component.options)
    } else {
      api.reload('7af6ca96', component.options)
    }
    module.hot.accept("./news-container.vue?vue&type=template&id=7af6ca96&", function () {
      api.rerender('7af6ca96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/news/news-container.vue"
export default component.exports